import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { motion } from "framer-motion";

const DirectReachUsSection = () => {
  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
      sx={{
        width: { xs: "calc(100% - 128px)", md: "362.66px" },
        height: "auto",
        bgcolor: "#F6F3F2",
        borderRadius: "8px",
        borderBottom: "2px solid #b69d95ff",
        boxShadow: "2px 2px 10px 0px rgba(0, 0, 0, 0.25)",
        pt: "26.5px",
        pl: "32px",
        pr: "32px",
        pb: "32px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start", // Top level flex-start
        position: "relative",
        ml: { xs: 0, md: "64px" },
      }}
    >
      {/* Title Section */}
      <Box
        sx={{
          width: "298.66px",
          height: "32px",
          mb: "32px",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Manrope, sans-serif",
            fontWeight: 400,
            fontSize: "24px",
            lineHeight: "32px",
            letterSpacing: "-0.6px",
            color: "#1C1B1B",
            textAlign: "left",
          }}
        >
          Direct Channels
        </Typography>
      </Box>

      {/* Content Boxes Section */}
      <Stack spacing="32px" sx={{ alignItems: "flex-start", width: "100%" }}>
        {/* Phone Box */}
        <Box
          sx={{
            width: "298.66px",
            height: "47.5px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start", // Internal flex-start
            gap: "3.5px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              color: "#57534E",
              textTransform: "uppercase",
              letterSpacing: "1px",
              lineHeight: 1, // Strict line height
              textAlign: "left",
            }}
          >
            General Inquiries
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "16px",
              color: "#1C1B1B",
              lineHeight: 1, // Strict line height
              textAlign: "left",
            }}
          >
            info@abilio.realty
          </Typography>
        </Box>

        {/* Email Box */}
        <Box
          sx={{
            width: "298.66px",
            height: "47.5px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start", // Internal flex-start
            gap: "3.5px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              color: "#57534E",
              textTransform: "uppercase",
              letterSpacing: "1px",
              lineHeight: 1, // Strict line height
              textAlign: "left",
            }}
          >
            Contact
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "16px",
              color: "#1C1B1B",
              lineHeight: 1, // Strict line height
              textAlign: "left",
            }}
          >
            +91 9000 133 018
          </Typography>
        </Box>

        {/* Location Box */}
        <Box
          sx={{
            width: "298.66px",
            height: "47.5px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start", // Internal flex-start
            gap: "3.5px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              color: "#57534E",
              textTransform: "uppercase",
              letterSpacing: "1px",
              lineHeight: 1, // Strict line height
              textAlign: "left",
            }}
          >
            Press & Media
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: "16px",
              color: "#1C1B1B",
              lineHeight: 1, // Strict line height
              textAlign: "left",
            }}
          >
            media@abilio.realty
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default DirectReachUsSection;
